import React from "react";

import AppTable from "@/components/AppTable";
import AppTableContainer from "@/components/AppTableContainer";
import AppTableHead from "@/components/AppTable/AppTableHead";
import AppTableRow from "@/components/AppTable/AppTableRow";
import AppTableBody from "@/components/AppTable/AppTableBody";
import AppTableCell from "@/components/AppTable/AppTableCell";
import AppTableHeaderCell from "@/components/AppTable/AppTableHeaderCell";
import AppBox from "@/components/AppBox";
import AppSwitch from "@/components/AppSwitch";
import AppIcon from "@/components/AppIcon";
import AppText from "@/components/AppText";
import AppTooltip from "@/components/AppTooltip";
import { appDate } from "@/utils/date";

interface AgencyAdminTableProps {
  tableRows: {
    name: string;
    customer_id: string;
    company: string;
    is_live: boolean;
    gls: boolean;
    sms: boolean;
    created_at: string;
  }[];
  onDelete: (row: any) => void;
  onChange: (field: string, row: any) => void;
  onLoginUnderUser: (row: any) => void;
}

const AgencyAdminTable: React.FC<AgencyAdminTableProps> = ({
  tableRows,
  onDelete,
  onChange,
  onLoginUnderUser,
}) => {
  const handleDelete = (row: any) => {
    onDelete(row);
  };

  return (
    <AppTableContainer>
      <AppTable>
        <AppTableHead>
          <AppTableRow>
            <AppTableHeaderCell>Agency User</AppTableHeaderCell>
            <AppTableHeaderCell>LSA Customer ID</AppTableHeaderCell>
            <AppTableHeaderCell>Date Added</AppTableHeaderCell>
            <AppTableHeaderCell>Features</AppTableHeaderCell>
            <AppTableHeaderCell>Actions</AppTableHeaderCell>
          </AppTableRow>
        </AppTableHead>

        <AppTableBody>
          {tableRows.length ? (
            tableRows.map((row, index) => (
              <AppTableRow key={index} className="hover:bg-gray-100">
                {/* Agency User */}
                <AppTableCell>
                  <AppText>{row.company}</AppText>
                </AppTableCell>

                {/* LSA Customer ID */}
                <AppTableCell>
                  <AppText>{row.customer_id}</AppText>
                </AppTableCell>

                {/* Date Added */}
                <AppTableCell>
                  <AppText>{appDate(row.created_at)}</AppText>
                </AppTableCell>

                {/* Features */}
                <AppTableCell>
                  <AppBox column gap={2}>
                    <AppSwitch
                      checked={!!row.is_live}
                      label="Allow access"
                      labelPosition="right"
                      onChange={() => onChange("is_live", row)}
                    />
                    <AppSwitch
                      checked={!!row.gls}
                      label="Message Autoresponder"
                      labelPosition="right"
                      onChange={() => onChange("gls", row)}
                    />
                    <AppSwitch
                      checked={!!row.sms}
                      label="Missed Call Text"
                      labelPosition="right"
                      onChange={() => onChange("sms", row)}
                    />
                  </AppBox>
                </AppTableCell>

                {/* Actions */}
                <AppTableCell>
                  <AppBox align="center" gap={4}>
                    <AppTooltip title="Click to enter this client's account">
                      <AppIcon
                        name="login"
                        className="w-5 h-5 text-green-500 cursor-pointer"
                        onClick={() => onLoginUnderUser(row)}
                        />
                    </AppTooltip>

                    <AppTooltip title="Delete User">
                      <AppIcon
                        name="trash"
                        className="w-5 h-5 text-red-500 cursor-pointer"
                        onClick={() => handleDelete(row)}
                        />
                    </AppTooltip>
                  </AppBox>
                </AppTableCell>
              </AppTableRow>
            ))
          ) : (
            <AppTableRow>
              <AppTableCell colSpan={5} className="text-center">
                No results
              </AppTableCell>
            </AppTableRow>
          )}
        </AppTableBody>
      </AppTable>
    </AppTableContainer>
  );
};

export default AgencyAdminTable;